export default __webpack_public_path__ + "static/media/clock.81f98072.svg";